module.exports = __webpack_public_path__ + "static/media/favicon-16x16.8464c9c6.png";